import Plyr from 'plyr';

export default () => {
  const player = new Plyr('#js-popupPlayer');

  const selectors = document.querySelectorAll('.js-player');

  selectors.forEach((selector) => {
    const player = new Plyr(selector);
  });
}